import { useMemo } from "react";
import type { MRT_Row } from "material-react-table";
import { isEventEditable, isEventNotStarted } from "../functions/isEventEditable.function";

interface UseFleetEventDetailTableEditingOptionsArgs {
  isEditable: boolean;
  timezone: string;
}

export function useFleetEventDetailTableEditingOptions({
  isEditable,
  timezone
}: Readonly<UseFleetEventDetailTableEditingOptionsArgs>) {
  return useMemo(() => {
    if (!isEditable) {
      return {
        enableEditing: false,
        enableRowSelection: false,
        enableRowActions: false
      };
    }

    return {
      enableEditing: (row: MRT_Row<any>) =>
        row.id === "mrt-row-create" || (!row.original.isPending && isEventEditable(row, timezone)),
      enableRowSelection: (row: MRT_Row<any>) =>
        !row.original.isPending && isEventNotStarted(row.original.start, timezone),
      enableRowActions: true
    };
  }, [isEditable, timezone]);
}
